import {observer} from "mobx-react";
import React, {TouchEvent, useRef} from "react";
import {VideoSlidesOnboardingOverlayBox} from "./boxes/video-slides-onboarding-overlay.box";
import {DotLottiePlayer} from "../../../lottie-player/dot-lottie-player.component";
import {DotLottieCommonPlayer} from "@dotlottie/react-player";
import {useServices} from "../../../../react-hooks/use-services.hook";
import {SwipingUserTipBox} from "./boxes/swiping-user-tip.box";
import { VideoSlidesTipTextBox } from "./boxes/video-slides-tip-text.box";
import {CyClass} from "../../../../../common/cy-classes";


interface VideoSlidesOnboardingComponentProps {
    onDismiss: () => void;
}

export const VideoSlidesOnboardingComponent: React.FC<VideoSlidesOnboardingComponentProps> = observer((props) => {
    let lottieRef = useRef<DotLottieCommonPlayer>(null);
    let services = useServices();


    const touchStartY = useRef(0);
    const touchEndY = useRef(0);

    const dismiss = () => {
        services.videoSlides.onBoardingWasShown = true;
        props.onDismiss();
        services.analytics.sendOrbitUserFlowEvent('videoSlides', 'dismiss', 'onBoarding');
    }


    const handleTouchStart = (e: TouchEvent<HTMLDivElement>) => {
        touchStartY.current = e.touches[0].clientY;
    };

    const handleSwipe = () => {
        const deltaY = touchStartY.current - touchEndY.current;
        if (deltaY > 40) {
            //Swiped up;
            dismiss();
        }
    };

    const handleTouchEnd = (e: TouchEvent<HTMLDivElement>) => {
        touchEndY.current = e.changedTouches[0].clientY;
        handleSwipe();
    };




    return (
      <VideoSlidesOnboardingOverlayBox onClick={dismiss}
                                       onTouchStart={handleTouchStart}
                                       onTouchEnd={handleTouchEnd}
                                       className={CyClass('cy-video-slides-onboarding-overlay')}
      >
          <SwipingUserTipBox>
              <DotLottiePlayer
                  style={{width: "100px", height: "100px"}}
                  ref={lottieRef}
                  src={services.theme.currentTheme.images.lottieAnimation.swipeGesture.toString()}
                  autoplay={true}
                  loop={true}
              />
              <VideoSlidesTipTextBox>
                  <p>{services.translation.translate("VIDEO_SLIDES_ONBOARDING_MAIN_TEXT")}</p>
                  <p>{services.translation.translate("VIDEO_SLIDES_ONBOARDING_SECONDARY_TEXT")}</p>
              </VideoSlidesTipTextBox>
          </SwipingUserTipBox>
      </VideoSlidesOnboardingOverlayBox>
    );
})